export default {
  EW: 'semiAnnually',
  EX: 'monthly',
  EY: 'biWeekly',
  EZ: 'weekly',
  FA: 'quarterly',
  FB: 'annually',
  FR: 'semiMonthly',
  FS: 'biMonthly',
  FQ: 'interestPaymentOnly',
  FT: 'singlePaymentLoan',
  FV: 'deferredPayment',
};
